import React from 'react';
import { chartTheme } from './Theme';
import { formatInr } from './utils';

const DonutChart = ({ data = [], width = '100%', size = 160, stroke = 20, showCenterTotal = true, bgColor = 'transparent', textColor = '#fff' }) => {
  const radius = (size - stroke) / 2;
  const cx = size / 2, cy = size / 2;
  const totalRaw = data.reduce((s, d) => s + (Number(d.value || 0)), 0);
  if (!data.length || totalRaw <= 0) {
    return (
      <div style={{ width: '100%', minHeight: 120, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.5)', fontSize: 12 }}>
        No data
      </div>
    );
  }
  const total = totalRaw || 1;
  let acc = 0;
  return (
    <svg viewBox={`0 0 ${size} ${size}`} width={width} height="120">
      <circle cx={cx} cy={cy} r={radius} fill={bgColor} stroke="rgba(255,255,255,0.1)" strokeWidth={stroke} />
      {data.map((d, i) => {
        const val = (Number(d.value || 0)) / total;
        const start = acc * Math.PI * 2 - Math.PI / 2;
        const end = (acc + val) * Math.PI * 2 - Math.PI / 2;
        acc += val;
        const x1 = cx + radius * Math.cos(start);
        const y1 = cy + radius * Math.sin(start);
        const x2 = cx + radius * Math.cos(end);
        const y2 = cy + radius * Math.sin(end);
        const large = end - start > Math.PI ? 1 : 0;
        const path = `M ${x1} ${y1} A ${radius} ${radius} 0 ${large} 1 ${x2} ${y2}`;
        const color = d.color || chartTheme.colors.donut[d.label] || chartTheme.colors.donut.OTHER;
        const pct = Math.round((Number(d.value || 0) / (total || 1)) * 100);
        return (
          <path key={i} d={path} stroke={color} strokeWidth={stroke} fill="none">
            <title>{`${d.label}: ${formatInr(d.value || 0)} (${pct}%)`}</title>
          </path>
        );
      })}
      {showCenterTotal && (
        <text x={cx} y={cy} textAnchor="middle" dominantBaseline="central" style={{ fontSize: 12, fill: textColor, fontWeight: 500 }}>
          {formatInr(total)}
        </text>
      )}
    </svg>
  );
};

export default DonutChart;


